import React, { useState } from "react";
import UserProfile from "../UserProfileInfo/UserProfile";
import "./NavigationBar.css";
import { IoMdPersonAdd } from "react-icons/io";
import { FaNewspaper } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import { MdOutlineLockReset } from "react-icons/md";
import { TiNews } from "react-icons/ti";


const NavigationBar = ({
	setActiveForm,
	showLastThree,
	setButtonClicked,
	setTitle,
}) => {
	const [activeButton, setActiveButton] = useState("Users");

	const handleButtonClick = (formName, label) => {
		setActiveForm(formName);
		setActiveButton(formName);
		setButtonClicked(true);
		setTitle(label);
	};

	const getIcon = (formName) => {
		switch (formName) {
			case "add":
				return <IoMdPersonAdd />;
			case "news":
				return <FaNewspaper />;
			case "newsDisplay":
				return <TiNews />;
			case "changePassword":
				return <MdOutlineLockReset />;
			case "Users":
			default:
				return <FaInfoCircle />;
		}
	};

	const commonButtonClass = "btn custom-button";
	const getButtonClass = (formName) =>
		`${commonButtonClass} ${
			activeButton === formName ? "btn-secondary" : "btn-outline-secondary"
		} text-start mt-2`;

	const renderButton = (formName, label) => (
		<button
			key={formName}
			onClick={() => handleButtonClick(formName, label)}
			className={getButtonClass(formName)}
		>
			{getIcon(formName)} {label}
		</button>
	);

	return (
		<nav className="navbar p-0">
			<div className="container-fluid d-flex flex-column p-0">
				<UserProfile />
				{["Users", !showLastThree && "add", "news", "newsDisplay", "changePassword"].map(
					(formName) =>
						formName &&
						renderButton(
							formName,
							formName === "Users"
								? "Anställd information"
								: formName === "add"
								? "Lägg till anställd"
								: formName === "news"
								? "Lägg till nyhet"
								: formName === "newsDisplay"
								? "Aktuella Nyheter"
								: "Ändra lösenord"
						)
				)}
			</div>
		</nav>
	);
};

export default NavigationBar;
